import React from 'react';
import { useLocation } from 'react-router-dom';
import NProgress from 'nprogress';

import { useDvaLoading } from '@/hooks/models';
import { FullHeightWrapperWithLoader } from '@/components/common/full-height-wrapper-with-loader';

NProgress.configure({ showSpinner: false });

let lastPathname: string | undefined;

interface AppProps {
  children: React.ReactNode;
}

function UnauthorizedApp({ children }: AppProps) {
  const routerLocation = useLocation();
  const loading = useDvaLoading();
  const isStartingUp = !!loading.effects['app/startup'];
  const { pathname } = routerLocation;

  if (lastPathname !== pathname) {
    NProgress.start();
    if (!loading.global) {
      NProgress.done();
      lastPathname = pathname;
    }
  }

  if (isStartingUp) {
    return <FullHeightWrapperWithLoader spinning>{children}</FullHeightWrapperWithLoader>;
  }

  return children;
}

export default UnauthorizedApp;
